module.exports = __webpack_public_path__ + "1642699981952/static/media/candidateJobsLogo.a9db7c97.svg";